// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rdrDateDisplayWrapper {
    background-color: transparent;
}

.rdrCalendarWrapper {
    font-family: "Sage UI Regular", sans-serif;
}

.rdrCalendarWrapper:not(.rdrNoSelection) .rdrInRange {
    background-color: var(--colorsActionMinor100);
}

.rdrDayToday .rdrDayNumber span:after {
    background-color: var(--colorsActionMinor500);
}

.rdrDay:not(.rdrDayPassive) .rdrInRange ~ .rdrDayNumber span {
    color: var(--colorsUtilityYin090);
}

.rdrMonthAndYearPickers {
    color: var(--colorsUtilityYin090);
    font-family: "Sage UI Medium", sans-serif;
    justify-content: flex-start;
}

.rdrCalendarWrapper:not(.rdrNoSelection) .rdrEndEdge {
  border-top-left-radius: 1.042em;
  border-bottom-left-radius: 1.042em;
}

.rdrDayToday {
    color: var(--colorsActionMinor500);
}

.rdrCalendarWrapper:not(.rdrNoSelection) .rdrStartEdge {
  border-top-right-radius: 1.042em;
  border-bottom-right-radius: 1.042em;
}

.rdrNoSelection .rdrSelected, 
.rdrNoSelection .rdrInRange,
.rdrNoSelection .rdrEndEdge,
.rdrNoSelection .rdrStartEdge {
  background: #fff;
}

.rdrNoSelection .rdrDay:not(.rdrDayPassive) .rdrInRange ~ .rdrDayNumber span,
.rdrNoSelection .rdrDay:not(.rdrDayPassive) .rdrStartEdge ~ .rdrDayNumber span,
.rdrNoSelection .rdrDay:not(.rdrDayPassive) .rdrEndEdge ~ .rdrDayNumber span,
.rdrNoSelection .rdrDay:not(.rdrDayPassive) .rdrSelected ~ .rdrDayNumber span {
  color: #000;
}

.rdrNoSelection .rdrDay:not(.rdrDayPassive) .rdrInRange ~ .rdrDayNumber span::after,
.rdrNoSelection .rdrDay:not(.rdrDayPassive) .rdrStartEdge ~ .rdrDayNumber span::after,
.rdrNoSelection .rdrDay:not(.rdrDayPassive) .rdrEndEdge ~ .rdrDayNumber span::after,
.rdrNoSelection .rdrDay:not(.rdrDayPassive) .rdrSelected ~ .rdrDayNumber span::after {
  background: #fff;
}
`, "",{"version":3,"sources":["webpack://./src/components/picker/custom-style.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;AACjC;;AAGE;IAAA;AAAgB;;AAIhB;IAAA;AAA0B;;AAI1B;IAAA;AAA0B;;AAI1B;IAAA;AAAkB;;AAInB;IAAA,iCAAkB;IAClB,yCAAmB;IACnB;AAFkB;;AAKnB;EACE,+BAA+B;EAC/B,kCAAkC;AACpC;;AAGE;IAAA;AAA4B;;AAG9B;EACE,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;;;;EAIE,gBAAgB;AAClB;;AAEA;;;;EAIE,WAAW;AACb;;AAEA;;;;EAIE,gBAAgB;AAClB","sourcesContent":[".rdrDateDisplayWrapper {\n    background-color: transparent;\n}\n\n.rdrCalendarWrapper {\n  @apply font-body;\n}\n\n.rdrCalendarWrapper:not(.rdrNoSelection) .rdrInRange {\n  @apply bg-action-minor-100;\n}\n\n.rdrDayToday .rdrDayNumber span:after {\n  @apply bg-action-minor-500;\n}\n\n.rdrDay:not(.rdrDayPassive) .rdrInRange ~ .rdrDayNumber span {\n  @apply text-yin-90;\n}\n\n.rdrMonthAndYearPickers {\n @apply text-yin-90;\n @apply font-heading;\n @apply justify-start;\n}\n\n.rdrCalendarWrapper:not(.rdrNoSelection) .rdrEndEdge {\n  border-top-left-radius: 1.042em;\n  border-bottom-left-radius: 1.042em;\n}\n\n.rdrDayToday {\n  @apply text-action-minor-500;\n}\n\n.rdrCalendarWrapper:not(.rdrNoSelection) .rdrStartEdge {\n  border-top-right-radius: 1.042em;\n  border-bottom-right-radius: 1.042em;\n}\n\n.rdrNoSelection .rdrSelected, \n.rdrNoSelection .rdrInRange,\n.rdrNoSelection .rdrEndEdge,\n.rdrNoSelection .rdrStartEdge {\n  background: #fff;\n}\n\n.rdrNoSelection .rdrDay:not(.rdrDayPassive) .rdrInRange ~ .rdrDayNumber span,\n.rdrNoSelection .rdrDay:not(.rdrDayPassive) .rdrStartEdge ~ .rdrDayNumber span,\n.rdrNoSelection .rdrDay:not(.rdrDayPassive) .rdrEndEdge ~ .rdrDayNumber span,\n.rdrNoSelection .rdrDay:not(.rdrDayPassive) .rdrSelected ~ .rdrDayNumber span {\n  color: #000;\n}\n\n.rdrNoSelection .rdrDay:not(.rdrDayPassive) .rdrInRange ~ .rdrDayNumber span::after,\n.rdrNoSelection .rdrDay:not(.rdrDayPassive) .rdrStartEdge ~ .rdrDayNumber span::after,\n.rdrNoSelection .rdrDay:not(.rdrDayPassive) .rdrEndEdge ~ .rdrDayNumber span::after,\n.rdrNoSelection .rdrDay:not(.rdrDayPassive) .rdrSelected ~ .rdrDayNumber span::after {\n  background: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
